// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XQ1o","inner":"Footer_inner__sq0Cm","nextIcon":"Footer_nextIcon__2YG68","innerLeft":"Footer_innerLeft__cxd78"};